const initialState = false;

export default function shoppingCartIsLoading(state = initialState, { type }) {
  switch (type) {
    // GET SYSTEMS
    case 'SHOPPING_CART_SEND_PRODUCTS_REQUEST':
      return true;
    case 'SHOPPING_CART_SEND_PRODUCTS_SUCCESS':
      return false;
    case 'SHOPPING_CART_SEND_PRODUCTS_FAILURE':
      return false;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/shopping-cart-is-loading.js